import classNames from 'classnames';
import PropTypes from 'prop-types';
import cryptoCurenciesImages from 'common/utils/import-cryptocurrencies-images.js'
import paypal from 'assets/images/payment/payout/paypal.svg';
import visa from 'assets/images/payment/payment-methods/visa_card.svg';
import visaDebit from 'assets/images/payment/visa-debit-v2.svg';
import discovercard from 'assets/images/payment/payment-methods/discover_card.svg';
import crypto from 'assets/images/payment/payment-methods/crypto.svg';
import { useState } from 'react';
import './style.scss'
import paymentImg from 'common/utils/import-payment-image';
import Image from 'common/components/modules/image';

const PaymentMethodImageCard = ({
   methodType,
   cardWidth,
   wrapperClassName,
   isHiddenCountItem,
   hiddenCount,
   onClickCard,
   isCryptoCurrency,
   primaryColor,
   showSeeAll = true,
   isHideHoverEffect = false,
   isNextApp,
}) => {

   const PAYMENT_IMAGES_BY_TYPES = {
      epoch_paypal: { image: paypal, title: 'PayPal' },
      segpay_paypal: { image: paypal, title: 'PayPal' },
      paypal: { image: paypal, title: 'PayPal' },
      visa_card: { image: visa, title: 'Visa' },
      visaCard: { image: visa, title: 'Visa' },
      visa: { image: visa, title: 'Visa' },
      visa_debit: { image: visaDebit, title: 'Visa Debit' },
      discover_card: { image: discovercard, title: 'Discover' },
      discover: { image: discovercard, title: 'Discover' },
      discoverNetwork: { image: discovercard, title: 'Discover' },
      boomfi: { image: crypto, title: 'Crypto', tooltipText: 'See all Cryptocurrencies' },
      segpay_crypto: { image: crypto, title: 'Crypto', tooltipText: 'See all Cryptocurrencies' },
      crypto: { image: crypto, title: 'Crypto', tooltipText: 'See all Cryptocurrencies' },
      master_card: { image: paymentImg.master_card, title: 'Master card' },
      maestro_card: { image: paymentImg.maestro_card, title: 'Maestro' },
      jcb_card: { image: paymentImg.jcb, title: 'JCB' },
      debit: { image: paymentImg.debitCard, title: 'Debit card' },
      diners_club_international_card: { image: paymentImg.diners_club_international_card, title: 'Diners club' },
      ccbill_pay: { image: paymentImg.ccbill_pay, title: 'Ccbill pay' },
      pay_by_bank: { image: paymentImg.pay_by_bank, title: 'Bank' },
   }

   const imgSrc = isCryptoCurrency ? cryptoCurenciesImages[methodType] : (PAYMENT_IMAGES_BY_TYPES[methodType]?.image || paymentImg[methodType])
   const [isHovered, setIsHovered] = useState(false)

   return (
      <div
         onMouseEnter={ () => setIsHovered(true) }
         onMouseLeave={ () => setIsHovered(false) }
         className={ classNames({
            'flex items-center justify-center px-1 py-1 rounded-[4px] border border-divider dark:border-divider-dark bg-panel shrink-0': true,
            'md:py-2 md:rounded-lg': !isNextApp,
            'fordesktop:py-2 fordesktop:rounded-lg': isNextApp,
            'cursor-pointer': isHiddenCountItem || onClickCard,
            [`${ wrapperClassName }`]: wrapperClassName,
            'hover:border-[1px]': methodType === 'crypto' && primaryColor,
            'payment-method-card': !isHideHoverEffect,
         }) }
         style={ {
            width: `${ cardWidth }px`,
            borderColor: isHovered && !isHideHoverEffect && primaryColor && !isHiddenCountItem ? primaryColor : '',
            boxShadow: isHovered && !isHideHoverEffect && primaryColor && !isHiddenCountItem ? `0 0 1px 0.5px ${ primaryColor }` : '',
         } }
         role='presentation'
         onClick={ onClickCard }
         data-tooltip-id='ams-top-tooltip'
         data-tooltip-content={ isHovered && !isHideHoverEffect && !isHiddenCountItem  ? PAYMENT_IMAGES_BY_TYPES[methodType]?.tooltipText : null }
      >
         {
            isHiddenCountItem ? (
               <span
                  className='text-xs leading-[14px] font-medium text-secondary'
               >
                  {showSeeAll ? 'See all' : `+${ hiddenCount }`}
               </span>
            ) : (
               <>
                  {/* isHovered && !isHideHoverEffect ? (
               ) : (
               ) */}
                  <p className='text-major text-xs font-medium text-center hidden payment-card-title'>
                     {/* Pay {methodType === 'pay_by_bank' ? 'by' : 'with'} { PAYMENT_IMAGES_BY_TYPES[methodType]?.title } */}
                     See all payment methods
                  </p>
                  <Image
                     src={ imgSrc }
                     alt={ methodType }
                     isNextApp={ isNextApp }
                     className='w-full h-full object-contain object-center'
                  />
               </>
            )
         }
      </div>
   )
}

PaymentMethodImageCard.propTypes = {
   methodType: PropTypes.string,
   cardWidth: PropTypes.number,
   wrapperClassName: PropTypes.string,
   isHiddenCountItem: PropTypes.bool,
   hiddenCount: PropTypes.number,
   onClickCard: PropTypes.func,
   isCryptoCurrency: PropTypes.bool,
   primaryColor: PropTypes.string,
   showSeeAll: PropTypes.bool,
   isHideHoverEffect: PropTypes.bool,
   isNextApp: PropTypes.bool,
}

export default PaymentMethodImageCard;
